import { t } from "i18next";

const AppVersion = () => {
    const version = '1.41.0';

    return (
        <div>
            <p>{t("App Version")}: {version}</p>
        </div>
    );
};

export default AppVersion;
